import { CHANNEL_CARE_UPDATE_COMPANY_ID } from './action-types';

export interface IUpdateCompanyIdAction {
    type: CHANNEL_CARE_UPDATE_COMPANY_ID;
    companyId: string;
};

export const updateCompanyIdAction = (companyId: string): IUpdateCompanyIdAction => ({
    type: CHANNEL_CARE_UPDATE_COMPANY_ID,
    companyId
});
